const qualification = {
    key1: '身份证',
    key2: '营业执照',
    key3: '医疗机构执业许可证',
    key4: '美容机构从业资格证',
    key5: '互联网药品交易服务许可证',
    key6: '互联网药品信息服务许可证',
    key7: '药品生产许可证',
    key8: '保健食品经营企业卫生许可证',
    key9: '医疗器械生产许可证',
    key10: '医疗器械经营许可证',
    key11: '兽药生产许可证',
    key12: '兽药经营许可证',
    key13: '司法鉴定机构执业许可证',
    key14: '特种行业许可证',
    key15: '化妆品生产企业卫生许可证',
    key16: '工业产品生产许可证',
    key17: '证券从业资格证',
    key18: '证券投资咨询业务资格证',
    key19: '证券经营机构营业许可证',
    key20: '期货从业资格证',
    key21: '期货经纪公司营业部经营许可证',
    key22: '律师执业许可证',
    key23: '律师事务所执业许可证',
    key24: '办学许可证',
    key25: '宗教活动场所登记证',
    key26: '网络文化经营许可证',
    key27: '经营股票承销业务资格证书',
    key28: '证券投资咨询业务资格证书',
    key29: '股票类客户推广代理商诺函',
    key30: '基金管理资格证书',
    key31: '基金代销业务资格证',
    key32: 'ICP备案证明',
    key33: '其他证明',
    key34: '半身照',
    key35: '商家Logo',
    key36: '事业单位法人登记证',
    key37: '组织机构代码证',
    key38: '工商、行政部门颁发的其他证书',
    key39: '教育局颁发的相关备案证书',
    key40: '身份证复印件（法人或特种行业许可证持有人）',
    key41: '烟草专卖零售许可证',
    key42: '省级卫生行政部门的消毒产品批准文号证明文件',
    key43: '"宗教团体"相关资质证明',
    key44: '临床试验证明文件',
    key45: '假肢和矫形器（辅助器具）生产装配企业资格认定书',
    key46: '进口兽药生产许可证或批准文号文件',
    key47: '进口兽药经营许可证或批准文号文件',
    key48: '企业法人营业执照',
    key49: '事业单位法人登记证',
    key50: '保健品（进口保健品）批准证书',
    key51: '保健品（进口保健品）注册批件',
    key52: '基金代销业务证书',
    key53: '中国人民银行批准文件',
    key54: '酒类专卖许可证',
    key57: '法人代表身份证',
    key55: '代办人身份证',
    key56: '公司委托办理证明',
    key58: '统一社会信用代码',
    key59: '经销商担保',
  };
const qualificationArray = Object.keys(qualification).map(key => ({ value: key, text: qualification[key] }));
const qualificationType = [
    {
        text: '主体资质',
        value: 1,
    },
    {
        text: '附加资质',
        value: 2,
    },
];
export {
    qualificationArray,
    qualificationType,
};
